import React, { useEffect } from 'react';

const ConfirmationModal = ({ isOpen, onClose, title, message }) => {
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div
            className="tw-fixed tw-inset-0 tw-z-50 tw-flex tw-items-center tw-justify-center tw-p-4"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}
            onClick={onClose}
        >
            <div
                className="tw-relative tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-max-w-md tw-w-full tw-p-8 tw-text-center"
                style={{
                    animation: 'modalFadeIn 0.3s ease-out',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                }}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Success Checkmark */}
                <div
                    className="tw-mx-auto tw-mb-6 tw-flex tw-items-center tw-justify-center tw-w-20 tw-h-20 tw-rounded-full tw-bg-dark-green"
                    style={{ animation: 'checkmarkPop 0.4s ease-out 0.2s both' }}
                >
                    <svg
                        className="tw-w-10 tw-h-10 tw-text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        style={{ animation: 'checkmarkDraw 0.5s ease-out 0.4s both' }}
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={3}
                            d="M5 13l4 4L19 7"
                        />
                    </svg>
                </div>

                {/* Title */}
                <h2 className="tw-text-2xl tw-font-bold tw-text-neutral-800 tw-mb-3">
                    {title || 'Thank You!'}
                </h2>

                {/* Message */}
                <p className="tw-text-lg tw-text-neutral-600 tw-mb-8 tw-leading-relaxed">
                    {message || 'Your request has been submitted successfully. We will get back to you soon.'}
                </p>

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="tw-px-10 tw-py-4 tw-bg-dark-green tw-text-white tw-font-bold tw-uppercase tw-rounded-lg tw-tracking-wider tw-transition-all tw-duration-200 hover:tw-opacity-90 tw-border-0 tw-cursor-pointer"
                    style={{ letterSpacing: '2px' }}
                >
                    Got it
                </button>
            </div>

            <style>{`
        @keyframes modalFadeIn {
          from {
            opacity: 0;
            transform: scale(0.9) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }
        @keyframes checkmarkPop {
          from {
            opacity: 0;
            transform: scale(0);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        @keyframes checkmarkDraw {
          from {
            stroke-dasharray: 100;
            stroke-dashoffset: 100;
          }
          to {
            stroke-dasharray: 100;
            stroke-dashoffset: 0;
          }
        }
      `}</style>
        </div>
    );
};

export default ConfirmationModal;
